import _get from "lodash/get";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createReducer } from 'redux-act';
import track from "./track";
import { setTransactionsFilter } from "../../actions";
export default createReducer(_defineProperty({}, setTransactionsFilter, function (state, meta) {
  var trackingState = _get(state, 'identity.tracking', null);

  track('Transactions.ChangeViewFilter', trackingState, _get(meta, 'filter'));
}));